function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "camera") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M55.643,401.273V178H33V383.484c0,16.071,10.889,29.449,25.879,33.984A41.668,41.668,0,0,1,55.643,401.273Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.873,158h383.7l2.406-10H65.873C48.62,148,34.427,162,33,178H55.63C60.726,166.589,72.36,158,85.873,158Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,135H395.665L385.9,114.419c-3.79-7.987-11.52-14.738-20.206-18.606A28.022,28.022,0,0,0,337.921,72H301.079a28.021,28.021,0,0,0-27.832,24.306c-8.251,3.942-15.51,10.508-19.143,18.167L244.335,135h-39.88a33.474,33.474,0,0,0-65.91,0H131V121.929A10.953,10.953,0,0,0,120,111H75a10.953,10.953,0,0,0-11,10.929V135.07a46.859,46.859,0,0,0-45,46.6V382.42C19,408.7,40.084,430,66,430H252a7,7,0,0,0,0-14H66c-17.888,0-33-15.339-33-33.58V181.668A32.88,32.88,0,0,1,66,149H446a32.88,32.88,0,0,1,33,32.668V382.42c0,18.241-15.112,33.58-33,33.58H389a7,7,0,0,0,0,14h57c25.916,0,47-21.305,47-47.58V181.668A46.9,46.9,0,0,0,446,135ZM301.079,86h36.842c5,0,9.4,2,11.893,6H289.186C291.683,88,296.074,86,301.079,86Zm-34.327,34.24C270.308,112.745,280.7,106,289,106h62c8.3,0,18.692,6.745,22.248,14.24L380.169,135H259.831ZM171.5,121.4A19.391,19.391,0,0,1,190.058,135H152.942A19.391,19.391,0,0,1,171.5,121.4ZM117,125v10H78V125Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5,245.935c-44.388,0-80.5,36.236-80.5,80.776s36.112,80.776,80.5,80.776S401,371.251,401,326.711,364.888,245.935,320.5,245.935Zm0,147.552A66.777,66.777,0,1,1,387,326.711,66.714,66.714,0,0,1,320.5,393.487Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5,201.77c-68.649,0-124.5,56.048-124.5,124.941a125.441,125.441,0,0,0,51.946,101.537,124.16,124.16,0,0,0,145.106,0A125.444,125.444,0,0,0,445,326.711C445,257.818,389.149,201.77,320.5,201.77Zm64.366,215.123a110.162,110.162,0,0,1-128.734,0A111.407,111.407,0,0,1,210,326.711c0-61.173,49.57-110.941,110.5-110.941S431,265.538,431,326.711A111.41,111.41,0,0,1,384.866,416.893Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.654b78f2a9ca2bf4f67367b9e729368f.svg";
export { ForwardRef as ReactComponent };